import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"20px","height":"20px"},
  viewBox: "2 5 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"
  })
], -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"20px","height":"20px"},
  viewBox: "2 5 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"
  })
], -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"20px","height":"20px"},
  viewBox: "2 5 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"
  })
], -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"20px","height":"20px"},
  viewBox: "2 5 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"
  })
], -1)
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"20px","height":"20px"},
  viewBox: "2 5 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"
  })
], -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"20px","height":"20px"},
  viewBox: "2 5 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"
  })
], -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"20px","height":"20px"},
  viewBox: "2 5 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"20px","height":"20px"},
  viewBox: "2 5 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "d-inline-block",
    style: { width: (_ctx.localCurrency && _ctx.cryptoCurrency ? '90' : '24') + 'px' }
  }, [
    (_ctx.pairType && _ctx.localCurrency && _ctx.cryptoCurrency)
      ? (_openBlock(), _createBlock("span", _hoisted_1, [
          (_ctx.pairType == 'fiat')
            ? (_openBlock(), _createBlock("span", _hoisted_2, [
                (!_ctx.reverse)
                  ? (_openBlock(), _createBlock("span", _hoisted_3, [
                      _createVNode("img", {
                        src: _ctx.getImgUrl(_ctx.localCurrency.toLowerCase()),
                        width: parseInt(_ctx.height)+5,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"]),
                      _createVNode("span", {
                        class: {'text-success': _ctx.color}
                      }, [
                        _hoisted_4
                      ], 2),
                      _createVNode("img", {
                        src: _ctx.getImgUrl(_ctx.cryptoCurrency.toLowerCase()),
                        width: parseInt(_ctx.height)+5,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"])
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_5, [
                      _createVNode("img", {
                        src: _ctx.getImgUrl(_ctx.cryptoCurrency.toLowerCase()),
                        width: parseInt(_ctx.height)+5,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"]),
                      _createVNode("span", {
                        class: {'text-danger': _ctx.color}
                      }, [
                        _hoisted_6
                      ], 2),
                      _createVNode("img", {
                        src: _ctx.getImgUrl(_ctx.localCurrency.toLowerCase()),
                        width: parseInt(_ctx.height)+5,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"])
                    ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.pairType == 'crypto')
            ? (_openBlock(), _createBlock("span", _hoisted_7, [
                (!_ctx.reverse)
                  ? (_openBlock(), _createBlock("span", _hoisted_8, [
                      _createVNode("img", {
                        src: require('@/assets/currencies/' + _ctx.localCurrency.toLowerCase() + '.svg'),
                        width: _ctx.height,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"]),
                      _createVNode("span", {
                        class: {'text-success': _ctx.color}
                      }, [
                        _hoisted_9
                      ], 2),
                      _createVNode("img", {
                        src: require('@/assets/currencies/' + _ctx.cryptoCurrency.toLowerCase() + '.svg'),
                        width: _ctx.height,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"])
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_10, [
                      _createVNode("img", {
                        src: require('@/assets/currencies/' + _ctx.cryptoCurrency.toLowerCase() + '.svg'),
                        width: _ctx.height,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"]),
                      _createVNode("span", {
                        class: {'text-danger': _ctx.color}
                      }, [
                        _hoisted_11
                      ], 2),
                      _createVNode("img", {
                        src: require('@/assets/currencies/' + _ctx.localCurrency.toLowerCase() + '.svg'),
                        width: _ctx.height,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"])
                    ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.pairType == 'mix')
            ? (_openBlock(), _createBlock("span", _hoisted_12, [
                (!_ctx.reverse)
                  ? (_openBlock(), _createBlock("span", _hoisted_13, [
                      _createVNode("img", {
                        src: require('@/assets/flags/' + _ctx.localCurrency + '.png'),
                        width: parseInt(_ctx.height)+5,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"]),
                      _createVNode("span", {
                        class: {'text-success': _ctx.color}
                      }, [
                        _hoisted_14
                      ], 2),
                      _createVNode("img", {
                        src: require('@/assets/currencies/' + _ctx.cryptoCurrency.toLowerCase() + '.svg'),
                        width: _ctx.height,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"])
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_15, [
                      _createVNode("img", {
                        src: require('@/assets/currencies/' + _ctx.cryptoCurrency.toLowerCase() + '.svg'),
                        width: _ctx.height,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"]),
                      _createVNode("span", {
                        class: {'text-danger': _ctx.color}
                      }, [
                        _hoisted_16
                      ], 2),
                      _createVNode("img", {
                        src: require('@/assets/flags/' + _ctx.localCurrency + '.png'),
                        width: parseInt(_ctx.height)+5,
                        height: _ctx.height,
                        alt: ""
                      }, null, 8, ["src", "width", "height"])
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock("span", _hoisted_17, [
          (_ctx.cryptoCurrency && _ctx.reverse)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _ctx.getImgUrl(_ctx.cryptoCurrency.toLowerCase()),
                width: _ctx.height,
                height: _ctx.height,
                alt: ""
              }, null, 8, ["src", "width", "height"]))
            : _createCommentVNode("", true),
          (_ctx.localCurrency && _ctx.cryptoCurrency && _ctx.reverse)
            ? (_openBlock(), _createBlock("span", {
                key: 1,
                class: {'text-danger': _ctx.color}
              }, [
                _hoisted_18
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.localCurrency)
            ? (_openBlock(), _createBlock("img", {
                key: 2,
                src: _ctx.getImgUrl(_ctx.localCurrency.toLowerCase()),
                width: parseInt(_ctx.height)+10,
                height: _ctx.height,
                alt: ""
              }, null, 8, ["src", "width", "height"]))
            : _createCommentVNode("", true),
          (_ctx.localCurrency && _ctx.cryptoCurrency && !_ctx.reverse)
            ? (_openBlock(), _createBlock("span", {
                key: 3,
                class: {'text-success': _ctx.color}
              }, [
                _hoisted_19
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.cryptoCurrency && !_ctx.reverse)
            ? (_openBlock(), _createBlock("img", {
                key: 4,
                src: _ctx.getImgUrl(_ctx.cryptoCurrency.toLowerCase()),
                width: _ctx.height,
                height: _ctx.height,
                alt: ""
              }, null, 8, ["src", "width", "height"]))
            : _createCommentVNode("", true)
        ]))
  ], 4))
}